// extracted by mini-css-extract-plugin
export var actionButton = "_da-t";
export var buttonContainer = "_da-0";
export var buttonContainer2 = "_da-1";
export var buttonSection = "_da-2";
export var details = "_da-3";
export var dropdownItem = "_da-5";
export var dropdownItemsContainer = "_da-4";
export var fileInput = "_da-r";
export var headerButton = "_da-6";
export var icon = "_da-7";
export var input = "_da-8";
export var macroListItem = "_da-9";
export var mainContent = "_da-a";
export var microText = "_da-b";
export var modal = "_da-w";
export var optionsButton = "_da-c";
export var paperclip = "_da-s";
export var pillContent = "_da-d";
export var preview = "_da-e";
export var preview2 = "_da-f";
export var quillEditor = "_da-q";
export var selectedMacro = "_da-g";
export var sidebar = "_da-h";
export var sidebarHeader = "_da-j";
export var sidebarList = "_da-i";
export var sidebarListItem = "_da-k";
export var sidebarSearch = "_da-l";
export var snoozeDurationWrapper = "_da-v";
export var statusPillContainer = "_da-m";
export var tagsContainer = "_da-n";
export var unselectedMacro = "_da-o";
export var variable = "_da-u";
export var wrapper = "_da-p";